/*
 *
 * Load frequently used libraries and attach to global/window.
 *
 */
import _ from 'lodash';
// import moment from 'moment';
import React from 'react';
import Money from '../lib/Money';
import dayjs from 'dayjs';

import {APP_VERSION, APP_TIMESTAMP} from '../../appVersion';

export function isClientSide() {
  try {
    return (typeof window !== 'undefined') && // OK
      (typeof window.document !== 'undefined'); // OK
  } catch (ex) {
    console.log("client side detection error: " + ex);
    return false;
  }
}


export function initGlobals() {
  // console.log("lodash version is " + _.VERSION);
  // Pollute global (window) object for backwards compatibility.
  // globalThis.application_root_url = "/";

  globalThis.Money = Money;
  globalThis._ = _;
  globalThis.isClientSide = isClientSide;
  globalThis.React = React;
  globalThis.dayjs = dayjs;

  // globalThis.moment = moment;
  // globalThis.URL_native = globalThis.URL;
  // globalThis.URL = url_parse;
  globalThis.APP_VERSION = APP_VERSION;
  globalThis.APP_TIMESTAMP = APP_TIMESTAMP;
}


